import { SessionStorageService } from '@core/services/session-storage.service';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { environment } from 'src/environments/environment';
import { inject, Injectable } from "@angular/core";
// import * as _ from 'lodash'
import { TosterService } from './toster.service';
// import { Md5 } from 'ts-md5';
// import { IRow } from '@core/interfaces/address';
import { CookieService } from 'ngx-cookie-service';
import { PospRedirectComponent } from '@features/posp-redirect/posp-redirect.component';
import { getConfig } from '@core/common/common-config';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { LocationService } from '@core/location-required/location-required.service';
// import { DeviceUUID } from 'device-uuid';

@Injectable({
	providedIn: "root",
})
export class AppData {
	// coords = inject(LocationService).coords;
	
	// public hasCalled: boolean = false;
	// setting base url in static variable  and we can change base url from here as per our api requirnment
	// _remitterLogin: BehaviorSubject<any> = new BehaviorSubject('');
	// static allBanlances: BehaviorSubject<any> = new BehaviorSubject('');
	static banners: BehaviorSubject<any> = new BehaviorSubject('');

	userLatLang: BehaviorSubject<any> = new BehaviorSubject<any>(null);
	// static remiiterLimit: BehaviorSubject<any> = new BehaviorSubject(null);
	static refundOtp: BehaviorSubject<any> = new BehaviorSubject(null);
	static permissionsData: BehaviorSubject<any> = new BehaviorSubject('');
	static dashboardSubMenu: BehaviorSubject<any> = new BehaviorSubject('');
	static timerStop: BehaviorSubject<any> = new BehaviorSubject('');
	public qrStatusUpdated: BehaviorSubject<boolean> = new BehaviorSubject(false);
	static qrCalled: BehaviorSubject<boolean> = new BehaviorSubject(false);
	static goToDashboard: BehaviorSubject<any> = new BehaviorSubject(false);

	static reportMenu: BehaviorSubject<any> = new BehaviorSubject(false);

	aepsLatLang: BehaviorSubject<any> = new BehaviorSubject<any>(null);


	// rowIdJson!: IRow;
	userId: string = ''

	constructor(private toaster: TosterService,
		private modalService: NgbModal,
		private sessionService: SessionStorageService) {
		// if (!this._userLatLong) {
		// 	this.getPosition().then((val: any) => {
		// 		//   ////console.log(val)
		// 		if (val) {
		// 			this.sessionService.setItem('latLng', val)
		// 			this.userLatLang.next(val)
		// 		}
		// 	});
		// }

	}

	async getAepsLatLong() {
		let returnAepsApiGeoData: any = '';

		try {
			// First, try fetching from aepsLatLang
			returnAepsApiGeoData = await this.aepsLatLang.getValue();
			console.log("Position from aeps API (BehaviorSubject):", returnAepsApiGeoData);

			// If data is found, return it and update session storage
			if (returnAepsApiGeoData?.lat && returnAepsApiGeoData?.lng) {
				this.sessionService.setItem('aepsLatLng', returnAepsApiGeoData);
				this.aepsLatLang.next(returnAepsApiGeoData);
			} else {
				// If data is not found, fall back to fetching from navigator
				returnAepsApiGeoData = await this.getLatLong();  // Call getLatLong to fetch from navigator
				console.log("Position from fallback (navigator):", returnAepsApiGeoData);
			}
		} catch (error) {
			// In case of error, use session storage as a fallback
			returnAepsApiGeoData = this.sessionService.getItem('aepsLatLng') || this.sessionService.getItem('latLng');
			if (returnAepsApiGeoData) {
				console.log("Using fallback data from session:", returnAepsApiGeoData);
			} else {
				throw new Error("Unable to retrieve lat/long data.");
			}
		}

		return returnAepsApiGeoData;
	}


	pospRedirectCondition() {
		let permission = this.sessionService.getItem('permissions');
		let userDetails = this.getUserDetails();

		if (permission?.insurance == 1) {
			window.open(userDetails?.assureUrl, '_blank');
		} else {
			this.openPospRedirectModal()
		}

	}

	openPospRedirectModal() {
		let mObj
		let confirmModalRef = this.modalService.open(PospRedirectComponent, getConfig('CONFIRM_BIG_MODAL_CONFIG'));
		confirmModalRef.componentInstance.modalObj = mObj;
		confirmModalRef.result.then((result) => {
			if (result) {
				console.log("result ", result)

			}
			else {
				console.log("cancel clicked");
			}

		}, err => {
			console.log(err);
		});
	}


	// async getLatLong() {
	// 	let cacheBS = false;
	// 	let cacheSession = false;
	// 	let returnData = this.userLatLang.getValue();
	// 	// //console.log("Initial returnData from userLatLang: ", returnData);

	// 	if (!returnData) cacheBS = true;

	// 	let positionFromSession = this.sessionService.getItem('latLng');
	// 	// //console.log("Position from session: ", positionFromSession);

	// 	if (!positionFromSession) cacheSession = true;

	// 	returnData ||= positionFromSession;

	// 	if (!returnData || !returnData.lat || !returnData.lng) {
	// 	  returnData = await this.getPositionFromNavigator();
	// 	//   //console.log("Position from navigator: ", returnData);
	// 	}

	// 	if (cacheSession) {
	// 	  this.sessionService.setItem('latLng', returnData);
	// 	  ////console.log("Setting position in session storage: ", returnData);
	// 	}
	// 	if (cacheBS) {
	// 	  this.userLatLang.next(returnData);
	// 	//   //console.log("Updating userLatLang: ", returnData);
	// 	}

	// 	return returnData;
	//   }


	async getLatLong() {
		let returnData: any = '';

		// Always fetch the latest position from the navigator
		try {
			returnData = await this.getPositionFromNavigator();
			console.log("Position from navigator: ", returnData);

			// Update session storage with the new data
			this.sessionService.setItem('latLng', returnData);
			//console.log("Setting position in session storage: ", returnData);

			// Update BehaviorSubject with the new data
			this.userLatLang.next(returnData);
			//console.log("Updating userLatLang: ", returnData);

		} catch (error) {
			//console.error("Error fetching latest lat/long data: ", error);

			// Fallback: If navigator fails, try to get from session
			returnData = this.sessionService.getItem('latLng');
			if (returnData) {
				//console.log("Using fallback data from session: ", returnData);
			} else {
				throw new Error("Unable to retrieve lat/long data.");
			}
		}

		return returnData;
	}


	private async getPositionFromNavigator() {
		try {
			const position = await new Promise<GeolocationPosition>((resolve, reject) => {
				navigator.geolocation.getCurrentPosition(resolve, reject);
			});
			return { lng: position.coords.longitude, lat: position.coords.latitude };
		} catch (error) {
			//console.error("Error getting position from navigator:", error);
			throw error;
		}
	}


	get _userLatLong() {
		return this.userLatLang.getValue();
	}

	// getting current positions
	async getPosition(): Promise<{ lng: number, lat: number }> {
		try {
			const position = await new Promise<GeolocationPosition>((resolve, reject) => {
				navigator.geolocation.getCurrentPosition(resolve, reject)
			})
			this.sessionService.setItem('latLng', { lng: position.coords.longitude, lat: position.coords.latitude })
			return { lng: position.coords.longitude, lat: position.coords.latitude };
		} catch (error: any) {
			this.toaster.showError('Please enable your location!')
			throw error
		}
	}

	setUserDetails(userDetails: any): void {
		this.sessionService.setItem('userDetails', userDetails);
		// this.sessionService.setCookies('userDetails', userDetails);
	}

	getUserDetails(): any {
		const userDetailsString = this.sessionService.getItem('userDetails');
		// const userDetailsString = this.sessionService.getCookies('userDetails');
		return userDetailsString ? userDetailsString : '';
	}



}
